import { render, staticRenderFns } from "./dlgTmplSelector.vue?vue&type=template&id=5cafb706"
import script from "./dlgTmplSelector.vue?vue&type=script&lang=js"
export * from "./dlgTmplSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports